import gql from 'graphql-tag';

import client from '../graphqlAPI';

const ADD_EDIT_OBJECT = gql`
  mutation Post($assetSlugName: String!, $fileReadableName: ObjectLocalizationInput, $filename: String, $fileExtension: String, $url: String, $description: ObjectLocalizationInput, $type: String, $tags: [String], $isPublic: Boolean, $fileSize: Int) {
    editMamObject(assetSlugName: $assetSlugName, fileReadableName: $fileReadableName, filename: $filename, fileExtension: $fileExtension, url: $url, description: $description, type: $type, tags: $tags, isPublic: $isPublic, fileSize: $fileSize) {
      assetSlugName
      filename
      isPublic
    }
  }
`;

const addEditMamObject = async ({
  assetSlugName, fileReadableName, filename, fileExtension, url, description, type, tags, isPublic, fileSize,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: ADD_EDIT_OBJECT,
        variables: {
          assetSlugName,
          fileReadableName,
          filename,
          fileExtension,
          url,
          description,
          type,
          tags,
          isPublic,
          fileSize,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { editMamObject: mamObjectData },
    } = result;

    if (mamObjectData) {
      return mamObjectData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Error: ${error}`);
    return null;
  }
};

export default addEditMamObject;
